import React from "react";
import { Trans } from 'react-i18next';
import { path } from 'ramda'
import { Helmet } from "react-helmet"

import { PrimaryButtonS, TabsButton, Text, } from "../common";
import Divider from "../common/Divider";
import { DisplayFlexS } from "../../../utils/stylesHelpers";
import Icon from "../common/Icon";
import VerifiedIcon from "../../assets/imgs/icons/Verified_Icon.svg";
import { PROFILE_TABS, TYPE_USER } from './profileContainer';
import { ChangeLogoModal, ChangePassModal } from "../modals";
import {
  BaseBlockStyled,
  CompanyLogoWrapS,
  ComponentProfileWrapS,
  HeaderTextS,
  HeaderWrapper,
  LogoWithUploadOverlayS,
  TabsBorderWrap,
  TabsWrapper,
  TitleInfoBlock
} from "./profileComponentS";
import { ProfileReviewsComponent } from "./profileReviewsComponent";
import { ProfileSettingsComponent } from "./profileSettingComponent";
import { getCompanyEditRoute } from '../../../utils/helpers/routesBuilder';

const ProfileComponent = ({
  company,
  handleActiveTabs,
  activeTab,
  windowWidth,
  onPagination,
  isReviewsLoading,
  reviews,
  reviewCount,
  typeUser,
  onSubmit,
  values,
  errors,
  onChange,
  onBlur,
  touched,
  push,
  updateAvatar,
  removeAvatar,
  isChangeAvatarOpened,
  toggleChangeAvatarModal,
  toggleChangePass,
  isChangePassOpen,
  isUserUpdate,
  isCompanyUpdate,
}) => (
  <>
    <Helmet>
      <title>Profile</title>
      <meta name="description" content="Profile page" />
      <meta property="og:title" content="Profile page"  />
      <meta property="og:description" content="Profile page"  />
      <meta property="og:url" content="https://treuhand-suche.ch/profile"  />
    </Helmet>

    <ComponentProfileWrapS>
      <ChangeLogoModal
        removeLogo={removeAvatar}
        updateLogo={updateAvatar}
        isModalOpen={isChangeAvatarOpened}
        toggleModal={toggleChangeAvatarModal}
      />
      {/* Will leave it as it will be implemented later */}
      <ChangePassModal
        isModalOpen={isChangePassOpen}
        toggleModal={toggleChangePass}
      />
      <HeaderTextS>
        <Trans i18nKey='profile.header'/>
      </HeaderTextS>
      {
        windowWidth > 768 ? <Divider height='2px' style={{ marginTop: 10 }}/> : null
      }
      <BaseBlockStyled>
        {
          windowWidth < 768 ? (
            <DisplayFlexS style={{ justifyContent: 'flex-end' }} >
              <PrimaryButtonS
                transform='none'
                fz='normalText'
                padding='6px 30px'
                onClick={() => push(getCompanyEditRoute(company._id, company.name))}
              >
                <Trans i18nKey='profile.button.editCompanyProfile'/>
              </PrimaryButtonS>
            </DisplayFlexS>
          ) : null
        }
        <HeaderWrapper>
          <CompanyLogoWrapS style={{ margin: 0 }}>
            <LogoWithUploadOverlayS
              logo={ company && company.logo }
            />
          </CompanyLogoWrapS>
          <DisplayFlexS justify='space-between'>
            <TitleInfoBlock>
              <Text align='left' fontFamily='bold' color='violet' size='bigText'>
                { path(['name'], company) }
              </Text>
              {
                company && company.verified && typeUser === TYPE_USER.COMPANY ? (
                  <DisplayFlexS style={{ marginTop: 10 }}>
                    <Text>
                      <Icon src={VerifiedIcon} size='18px' />
                    </Text>
                    <Text size='bigText' style={{ marginLeft: 5 }}>
                      <Trans i18nKey={path(['verified'], company) ? 'companyItem.verified' : 'companyItem.notVerified'} />
                    </Text>
                  </DisplayFlexS>
                ) : null
              }
            </TitleInfoBlock>
            <DisplayFlexS justify='flex-end' style={{ alignItems: 'center' }}>
              {
                windowWidth > 768 && typeUser === TYPE_USER.COMPANY ? (
                  <PrimaryButtonS
                    transform='none'
                    fz='normalText'
                    padding='6px 30px'
                    onClick={() => push(getCompanyEditRoute(company._id, company.name))}
                  >
                    <Trans i18nKey='profile.button.editCompanyProfile'/>
                  </PrimaryButtonS>
                ) : null
              }
            </DisplayFlexS>
          </DisplayFlexS>
        </HeaderWrapper>
        <DisplayFlexS direction='column' directionScreenMedium='column'>
          <TabsBorderWrap>
            <TabsWrapper>
              {
                Object.keys(PROFILE_TABS).map( key =>
                  <TabsButton
                    selected={ activeTab.index === PROFILE_TABS[key].index }
                    key={ PROFILE_TABS[key].index }
                    onClick={ () => handleActiveTabs(PROFILE_TABS[key]) }
                    borderColor='grayBlue'
                  >
                    { PROFILE_TABS[key].index === 0 ? (
                      <Text>
                        <Trans i18nKey={PROFILE_TABS[key].text}/> { `(${reviewCount})` }
                      </Text>) : (
                      <Text>
                        <Trans i18nKey={PROFILE_TABS[key].text}/>
                      </Text>)
                    }
                  </TabsButton>
                )
              }
            </TabsWrapper>
          </TabsBorderWrap>
          {
            activeTab === PROFILE_TABS.comments ?
              (
                <ProfileReviewsComponent
                  reviews={ reviews }
                  reviewCount={ reviewCount }
                  windowWidth={ windowWidth }
                  onPagination={ onPagination }
                  isReviewsLoading={ isReviewsLoading }
                />
              ) :
              (
                <ProfileSettingsComponent
                  company={company}
                  typeUser={typeUser}
                  onSubmit={onSubmit}
                  values={values}
                  errors={errors}
                  onChange={onChange}
                  onBlur={onBlur}
                  touched={touched}
                  toggleChangeAvatarModal={toggleChangeAvatarModal}
                  toggleChangePass={toggleChangePass}
                  windowWidth={windowWidth}
                  loadingPost={isUserUpdate || isCompanyUpdate}
                />
              )
          }

        </DisplayFlexS>
      </BaseBlockStyled>
    </ComponentProfileWrapS>
  </>
)

export default ProfileComponent;
